var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[[_c('v-btn',{attrs:{"color":"white"},on:{"click":_vm.click}},[_c('v-icon',{staticClass:"grey--text"},[_vm._v("mdi-map-marker-radius")])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }